import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionReducer from "./sessionReducer";
import commonReducer from "./commonReducer";
import UsersReducer from "../pages/UserListing/reducers/UsersReducer";
import ApplicationReducer from "../pages/Application/reducers/ApplicationReducer";
import TimeZonesReducer from "../pages/Timezone/reducers/TimeZonesReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["session"],
};

const appReducer = combineReducers({
  session: sessionReducer,
  commonState: commonReducer, // Now correctly imported
  usersState: UsersReducer,
  applicationState: ApplicationReducer,
  timeZonesState: TimeZonesReducer,
});

const RootReducer = (state, action) => {
  if (action.type === "TOKEN_EXPIRE" || action.type === "SESSION_LOGOUT") {
    state = undefined;
    localStorage.removeItem("token");
    sessionStorage.clear();
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, RootReducer);
